import React, { useCallback, useMemo } from 'react'
import { useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'

import EditForm from '../../../../../../features/components/Forms/EditForm'
import MultipleGoogleMediaUpload from '../../../GoogleAssetGroup/GoogleAssetGroupCreate/GoogleAssetGroupForm/GoogleAssetGroupMainForm/MultipleGoogleMediaUpload'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'
import { useEditSectionFormSubmit } from '../../../../../../hooks/formHooks/useEditSectionFormSubmit'

import { updateAd } from '../../../../../../modules/actions/ads'
import { selectedGoogleAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { getInitialValues, validationSchema } from './fields'
import { getImageAssets, SQUARE_IMAGE, squareImageHeight, squareImageWidth } from '../../../fields'
import { GOOGLE_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { squareImageValidationSchema } from '../../../validations'
import { HISTORY_META_EDIT_SECTION } from '../../../../../../constants/changeHistory'

const SquareImageSectionForm = ({
  editItemData: ad,
  successSubmit,
  isInternalAd,
  title,

  ...formProps
}) => {
  const dispatch = useDispatch()

  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)

  const { id, ad_account_id: adAccountId } = ad
  const adAccount = adAccountId || selectedAdAccountId

  const initialValues = useMemo(() => getInitialValues(ad), [ad])

  const handleSubmit = useCallback(
    values => {
      dispatch(
        updateAd(
          {
            account: adAccount,
            responsive_display_ad: {
              square_marketing_images: getImageAssets(values[SQUARE_IMAGE])
            },
            ...(isInternalAd && { internal: true }),
            meta: {
              [HISTORY_META_EDIT_SECTION]: title
            }
          },
          id,
          GOOGLE_PLATFORM
        )
      )
    },
    [dispatch, id, isInternalAd, adAccount, title]
  )

  const { onSubmit, manualSuccessSubmit } = useEditSectionFormSubmit({ initialValues, handleSubmit })

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    enableReinitialize: true
  })

  const purifiedFormik = usePurifiedFormik(formik)

  const { values } = purifiedFormik

  const isEmptyList = !values[SQUARE_IMAGE].length

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      successSubmit={successSubmit || manualSuccessSubmit}
      {...formProps}
    >
      <MultipleGoogleMediaUpload
        formik={purifiedFormik}
        FileItemPath={SQUARE_IMAGE}
        validationSchema={squareImageValidationSchema}
        addAnotherButtonText={isEmptyList ? 'Add square image' : 'Add another square image'}
        width={squareImageWidth}
        height={squareImageHeight}
      />
    </EditForm>
  )
}

export default SquareImageSectionForm
